module.exports = __webpack_public_path__ + "media/bootstrap-icons/gender-ambiguous-32e38878.svg";